/* ANGE Projects — measures the announcement bar's rendered height and
   exposes it as a CSS custom property, so the sticky header can be offset
   to sit directly below the always-visible sticky announcement bar. */
(function () {
  function setAnnouncementBarHeight() {
    var bar = document.querySelector('.announcement-bar-section .utility-bar');
    var height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
  }

  setAnnouncementBarHeight();
  window.addEventListener('load', setAnnouncementBarHeight);
  window.addEventListener('resize', setAnnouncementBarHeight);
})();
